/* HALE PDP add-ons (product pages only):
   1) inject a "Консультація" button next to "Додати в кошик" that opens
      the quiz/consult modal, with analytics (consult events);
   2) mobile sticky ATC offset above the app dock (handled in CSS, 106px).

   Phase 0 (2026-09-08): the Flow cart-drawer fallback that used to live here
   was removed — the Hale drawer (snippets/hale-cart-drawer.liquid) is the only
   cart UI, and the branch started with `if ([data-cart-drawer]) return`, i.e.
   it never ran. */
(function(){
  /* analytics helper (shared with hale-mobile / hale-modals; Phase 1 moves it to hale-core) */
  window.haleTrack = window.haleTrack || function(name, params){
    params = params || {};
    try{ window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({event:name}, params)); }catch(e){}
    try{ if(typeof window.gtag === 'function') window.gtag('event', name, params); }catch(e){}
    try{ if(typeof window.fbq === 'function') window.fbq('trackCustom', name, params); }catch(e){}
  };

  var PRODUCT = (window.meta && window.meta.product && window.meta.product.handle) || location.pathname.split('/products/')[1] || '';

  /* ---- inject "Консультація" button beside the add-to-cart button ---- */
  function injectConsult(){
    var row=document.querySelector('.hale .pdp-form .qtyrow');
    if(!row || row.querySelector('[data-pdp-consult]')) return;
    var add=row.querySelector('.addbig'); if(!add) return;
    var b=document.createElement('button');
    b.type='button';
    b.className='pdp-consult-btn';
    b.setAttribute('data-pdp-consult','');
    b.setAttribute('data-open-quiz','');
    b.setAttribute('data-hale-quiz','');
    b.setAttribute('data-quiz-src','pdp-atc');
    b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M4 5h16v11H9l-5 4z"/><path d="M8 9.5h8M8 12.5h5"/></svg><span>Консультація фітотерапевта</span>';
    row.appendChild(b);
  }

  /* consult / quiz analytics (fires for the injected btn AND the block button) */
  document.addEventListener('click',function(e){
    var q = e.target.closest && e.target.closest('[data-hale-quiz], [data-open-quiz], [data-open-consult], .pconsult, [data-pdp-consult]');
    if(!q) return;
    var src = q.getAttribute('data-quiz-src') || (q.classList && q.classList.contains('pconsult') ? 'pdp-block' : 'pdp');
    window.haleTrack('consult_open', { source: src, product: PRODUCT, page: location.pathname });
  });

  function boot(){ injectConsult(); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', injectConsult);

  /* styles for the injected button */
  var css='.hale .pdp-form .qtyrow{flex-wrap:wrap;}'+
    '.hale .pdp-consult-btn{flex:1 1 100%;display:inline-flex;align-items:center;justify-content:center;gap:9px;margin-top:2px;min-height:48px;padding:0 18px;border-radius:30px;background:transparent;color:var(--accent);border:1px solid var(--accent);font-family:var(--serif,Georgia,serif);text-transform:uppercase;letter-spacing:.07em;font-size:12.5px;cursor:pointer;transition:background .2s,color .2s;}'+
    '.hale .pdp-consult-btn:hover{background:var(--accent);color:var(--on-accent,#fff);}'+
    '.hale .pdp-consult-btn svg{width:17px;height:17px;flex:0 0 auto;}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);
})();